import { type CalendarZoom } from "@/features/calendar/types";
import styled from "@emotion/styled";
import { LightMode, Variables } from "@repo/skapa";
import { isToday } from "date-fns";
import { type RefObject, useEffect } from "react";

import { getZoomHourWidth } from "../utils/utils";
import { NAME_COL_WIDTH } from "./constants";

const VerticalLine = styled.div<{ left: number }>`
  position: absolute;

  z-index: 2;

  top: 0;
  left: ${({ left }) => left}px;
  right: ${({ left }) => left + 2}px;
  bottom: 0;

  width: ${Variables.thicknessThick};

  background-color: ${LightMode.colourSemanticNegative};
`;
export const zoomTimeline = (
  timelineRef: RefObject<HTMLDivElement | null>,
  delay: number
) => {
  setTimeout(() => {
    timelineRef?.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
      inline: "center",
    });
  }, delay);
};

export const CurrentTimeLine = ({
  selectedDate,
  startHour,
  totalHours,
  zoom,
  timelineRef,
}: {
  selectedDate: Date;
  startHour: number;
  totalHours: number;
  zoom: {
    zoom: CalendarZoom;
    zoomWidth: number;
  };
  timelineRef: RefObject<HTMLDivElement | null>;
}) => {
  useEffect(() => {
    zoomTimeline(timelineRef, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  const pixelsPerMinute = getZoomHourWidth(zoom, totalHours) / 60;

  const selectedHour = currentHour - startHour;

  const pos =
    selectedHour * getZoomHourWidth(zoom, totalHours) +
    currentMinute * pixelsPerMinute +
    NAME_COL_WIDTH;

  // Don't show the line before or after the calendar
  if (selectedHour < 0 || selectedHour >= totalHours) {
    return null;
  }

  if (!isToday(selectedDate)) {
    return null;
  }

  return <VerticalLine left={pos} ref={timelineRef} />;
};
